<template>
  <div class="block center">
    <div>
      <p class="no-data">No Data In Database</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DatabaseNotFound'
}
</script>

<style>
.center {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.no-data {
  font-size: 150%;
}
</style>
